// import getUserInfo from "../queries/3dmssapi/get-user-info"

import getCookieValue from "../utils/get-cookie-value"


const isUserSignedIn = () =>  {
  const cookie_value = getCookieValue('uid')

  return cookie_value ? true : false
}

export default isUserSignedIn
